const EXPOSURE_ID_RE = /^[a-z0-9]{12,32}$/;

/** Generate an opaque, bounded ID for one expanded peek presentation. */
export function newExposureId(random: () => number = Math.random): string {
  const time = Date.now().toString(36);
  let suffix = "";
  for (let i = 0; i < 10; i += 1) suffix += Math.floor(random() * 36).toString(36);
  return `${time}${suffix}`.slice(-24);
}

export function isExposureId(value: unknown): value is string {
  return typeof value === "string" && EXPOSURE_ID_RE.test(value);
}
